import { ROOT_FONT_SIZE_PX } from '../layout-root-font-size.constant';

/** Fixed topbar height in `rem`, mirroring `--layout-topbar-height`. */
const TOPBAR_HEIGHT_REM = 3.5;

/**
 * Returns the rendered height of the app shell topbar (`.layout-topbar`) in
 * pixels — the single source of truth for scroll offsets that must clear the
 * fixed topbar.
 *
 * Prefers measuring the live element so the value tracks the real rendered
 * height (borders, future padding, a different root font size). Falls back to
 * `--layout-topbar-height` (3.5rem) resolved against the root font size when
 * the topbar is not in the DOM (SSR / unit tests).
 *
 * @example
 * const offset = getLayoutTopbarHeightPx(); // 56 at the default 16px root
 */
export function getLayoutTopbarHeightPx(): number {
  if (typeof document === 'undefined') {
    return TOPBAR_HEIGHT_REM * ROOT_FONT_SIZE_PX;
  }
  const topbar = document.querySelector('.layout-topbar');
  if (topbar instanceof HTMLElement) {
    return topbar.getBoundingClientRect().height;
  }
  const rootFontSize =
    Number.parseFloat(getComputedStyle(document.documentElement).fontSize) ||
    ROOT_FONT_SIZE_PX;
  return rootFontSize * TOPBAR_HEIGHT_REM;
}
